export default [
  {
    path: '/terms',
    component: () => import(/* webpackChunkName: "stock-reports" */ './Terms.vue'),
  },
  {
    path: '/privacy-policy',
    component: () => import(/* webpackChunkName: "stock-reports" */ './PrivacyPolicy.vue'),
  },
];
